const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserWorkshops', ['Application', 'Authorization', 'UserWorkshops', function (Application, Authorization, UserWorkshops) {
  return {
    restrict: 'E',
    scope: {
      user: '=',
      initKey: '=',
      initVal: '@',
      managerOverride: '@?'
    },
    replace: true,
    template: require('../../templates/directives/admin-user-workshops.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      self.employee = $scope.user;
      self.pages = [null];

      self.per_page = 10;
      self.page = 1;
      self.nextAvailable = true;

      if (self.user.role !== 'admin' && !$scope.managerOverride) {
        Application.navigation.goTo('/explore');
      }

      self.parsePage = function(results) {
        var list = [];

        results.forEach(function(item) {
          if (!item.workshop || !item.workshop_instance) {
            list.push({});
            return;
          }

          var statusDirectory = {
            registered: 'Registered',
            waiting: 'Waiting',
            attended: 'Attended',
            absent: 'Absent'
          };

          var block = {
            workshopName: item.workshop.title || '--',
            workshopDate: item.workshop_instance.start_date && moment(item.workshop_instance.start_date).tz(item.workshop_instance.viewing_timezone).format('dddd, MMMM D, YYYY (h:mma z)') || '--',
            status: statusDirectory[item.active_status] || '--',
            statusDate: item.status_changed && moment(item.status_changed).tz(item.workshop_instance.viewing_timezone).format('dddd, MMMM D, YYYY (h:mma z)')
          };

          list.push(block);
        });

        return list;
      };

      self.getUserWorkshops = function(views) {
        if (!self.employee) {
          return;
        }

        self.loading = true;

        var req = {
          user: self.employee,
          page: self.page || 1,
          per_page: self.per_page || 10,
          active_status: '$ne,removed',
          fields: 'user,active_status,workshop_instance,workshop,status_changed',
          'workshop-populate': 'title',
          'workshop_instance-populate': 'start_date,viewing_timezone',
          sort: 'status_changed,-1'
        };

        UserWorkshops.find(req).$promise
        .then(function(results) {
          self.pages[self.page] = self.parsePage(results);
          self.currentPage = self.page;
          self.nextAvailable = true;
          if (results.length < self.per_page) {
            self.nextAvailable = false;
          }
          self.loading = false;
        });
      };

      self.changePage = function(next) {
        if (!next) {
          if (self.page > 1) {
            self.page = self.page - 1;
          }
          self.currentPage = self.page;
          self.nextAvailable = true;
          return;
        }

        self.nextAvailable = true;
        if (self.pages[self.page] && self.pages[self.page].length < self.per_page) {
          self.nextAvailable = false;
          return;
        }

        self.page = self.page + 1;

        if (self.pages[self.page]) {
          self.currentPage = self.page;
          return;
        }

        self.getUserWorkshops();
      };

      self.initialize = function() {
        self.getUserWorkshops();
      };

      if ($scope.initKey !== $scope.initVal) {
        var watchKey = $scope.$watch('initKey', function(newVal, oldVal) {
          if (newVal === $scope.initVal) {
            self.employee = $scope.user;
            self.initialize();
            watchKey();
          }
        });
        return;
      }

      self.initialize();
    }],
    controllerAs: 'userWorkshops'
  }
}]);